import React from "react";

export default function Guild() {
  return <div className="p-8">Guild / Breaslă (coming soon)</div>;
}
